import React from 'react'
import { i18n } from '../../index'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import UserUpdateForm from './UserUpdateForm'
import type { User } from './userTypes'
import css from './Users.css'
type Props = {
  data: User
  isOpen: boolean
  onClose: (...args: Array<any>) => any
}

const UserEditDialog = (props: Props) => {
  const { data, isOpen, onClose } = props
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby='form-dialog-title'
      className={css.component}
      classes={{
        paperWidthSm: css.userEditDialog,
      }}
    >
      <DialogTitle id='form-dialog-title'>{i18n.t('admin.user.updateDialogTitle')}</DialogTitle>
      <DialogContent>
        <UserUpdateForm data={data} onCancel={onClose} />
      </DialogContent>
    </Dialog>
  )
}

export default UserEditDialog
